import { TrendingUp, Users } from "lucide-react";

export function WidgetClientiCommerciali() {
  return (
    <div className="space-y-3 text-xs">
      <p className="text-muted-foreground">
        Diventerà attivo con M5 Cruscotto Commerciale. Quando ci arriveremo,
        questo widget mostrerà:
      </p>
      <ul className="space-y-2">
        <Item
          icon={Users}
          titolo="Top clienti"
          esempio="Classifica clienti per fatturato 12 mesi, con trend e percentuale del totale."
        />
        <Item
          icon={TrendingUp}
          titolo="Commesse critiche per cliente"
          esempio="Commesse in ritardo / parziali / inevadibili raggruppate per cliente strategico."
        />
      </ul>
    </div>
  );
}

function Item({
  icon: Icon,
  titolo,
  esempio,
}: {
  icon: typeof Users;
  titolo: string;
  esempio: string;
}) {
  return (
    <li className="flex gap-2 items-start">
      <Icon className="size-3.5 text-muted-foreground mt-0.5 shrink-0" />
      <div>
        <p className="font-medium text-foreground">{titolo}</p>
        <p className="text-muted-foreground">{esempio}</p>
      </div>
    </li>
  );
}
